import { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function QuillEditor() {

    const [value, setValue] = useState('');
    const [render, rerender] = useState(false);

    useEffect(() => {
        rerender(!render)
    }, [])
    

    return (
        <ReactQuill
            style={{
                background: "#D6F0CC",
                color: "black",
                width:"100%",
                margin:"1em"
            }}
            theme="snow"
            value={document.getElementById("textArea")?.value}
            onChange={() => {
                setValue(value)
                document.getElementById("textArea").value = document.getElementsByClassName("ql-editor")[0].innerHTML
            }}
        />
    );
}